export default __webpack_public_path__ + "static/media/job-blue.1ad4a1ea.svg";